import React from 'react';
import { Card } from '../components/ui/Card';

/**
 * Settings page component
 * 
 * @returns {JSX.Element} Settings page component
 */
export const Settings: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-agentic-text-primary">Settings</h1>
        <p className="text-agentic-text-secondary mt-1">
          Configure your application preferences
        </p>
      </div>

      <Card title="Application Settings" subtitle="Coming soon">
        <div className="h-96 flex items-center justify-center bg-agentic-gray-50 rounded-lg">
          <div className="text-center">
            <p className="text-agentic-text-secondary">Settings features will be implemented here</p>
          </div>
        </div>
      </Card>
    </div>
  );
};

